import { render, staticRenderFns } from "./site-alert.vue?vue&type=template&id=14ed088e&scoped=true"
import script from "./site-alert.vue?vue&type=script&lang=js"
export * from "./site-alert.vue?vue&type=script&lang=js"
import style0 from "./site-alert.vue?vue&type=style&index=0&id=14ed088e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ed088e",
  null
  
)

export default component.exports